import { render, staticRenderFns } from "./BanksReport.vue?vue&type=template&id=f53a3c76&"
import script from "./BanksReport.vue?vue&type=script&lang=js&"
export * from "./BanksReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports